import React, { useState } from 'react';
// react-bootstrap
import { Container } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

// styles
import { Wrapper } from './Form.styles';

const ForgotPasswordForm = ({ callback, disabled }) => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!email) {
      setError('Please enter email');
      return;
    }

    if (
      !/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        email
      )
    ) {
      setError('Enter a valid email address!');
      return;
    }

    callback(email);
  };

  return (
    <Wrapper>
      <Container>
        <h1 className={'form-title'}>Forgot Password</h1>
        <Form onSubmit={handleSubmit}>
          <Form.Group className='mb-3' controlId='formGroupEmail'>
            <Form.Label>Email address</Form.Label>
            <Form.Control
              type='email'
              placeholder='Enter email'
              name='email'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              isInvalid={error}
            />
            {
              <Form.Control.Feedback type='invalid'>
                {error}
              </Form.Control.Feedback>
            }
          </Form.Group>
          <div className='d-grid gap-2 mx-5 mt-5 mb-3'>
            <Button size='lg' type='submit' disabled={disabled}>
              Send Email
            </Button>
          </div>
        </Form>
      </Container>
    </Wrapper>
  );
};

export default ForgotPasswordForm;
